require("google-webfonts-sourcesanspro");

require("font-awesome-webpack");
import './sass/main.scss';

require("imports-loader?jQuery=jquery!./js/main.js");
require('./js/util.js');
require('./js/jquery.dropotron.min.js');
require('./js/jquery.scrollgress.min.js');



// WEBPACK FOOTER //
// ./assets/vendor/html5up-alpha/index.js